'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const CuriosityList = createPage(
	() => import('@/features/for-you/components/Curiosity'),
);

export default function CuriosityPage() {
	return <CuriosityList />;
}
